import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { EventCard } from "@/components/EventCard";
import { PageHeader, Spinner, EmptyState } from "@/components/common";

export default function Events() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get("/events", { params: { status: "upcoming" } }),
      api.get("/events", { params: { status: "coming_soon" } }),
    ]).then(([u, c]) => setEvents([...u.data, ...c.data])).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="events-page">
      <PageHeader caption="Live Experiences" title="Events" subtitle="Browse upcoming shows and grab your tickets before they're gone." />
      <div className="mx-auto max-w-7xl px-4 pb-10 sm:px-8">
        {loading ? <Spinner /> : events.length ? (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {events.map((e) => <EventCard key={e.id} event={e} />)}
          </div>
        ) : <EmptyState text="No upcoming events right now. Check back soon." />}
      </div>
    </div>
  );
}
